import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../axiosInstance";

// ================= SERVER STATS =================
export const getServerStats = createAsyncThunk(
  "analysis/serverStats",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/analysis/server");
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// ================= VIEWS PER MONTH =================
export const getViewsPerMonth = createAsyncThunk(
  "analysis/viewsPerMonth",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/analysis/views");
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// ================= LAST 5 COMMENTS =================
export const getLastComments = createAsyncThunk(
  "analysis/lastComments",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/analysis/comments");
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// ================= WRITERS STATS =================
export const getWritersStats = createAsyncThunk(
  "analysis/writersStats",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/analysis/status");
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// ================= POSTS BY DAY =================
export const getPostsByDay = createAsyncThunk(
  "analysis/postsByDay",
  async ({ writerId, date }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `/analysis/${writerId}/posts-day?date=${date}`,
      );
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// ================= SUBCATEGORIES STATS =================
export const getSubcategoriesStats = createAsyncThunk(
  "analysis/subcategoriesStats",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/analysis/subCategories");
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// ================= TOP POSTS =================
export const getTopPosts = createAsyncThunk(
  "analysis/topPosts",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/analysis/topPosts");
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// ================= PROFILES POSTS =================
export const getProfilesPostsStats = createAsyncThunk(
  "analysis/profilesPostsStats",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/analysis/profilesPosts");
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// ================= LAST POSTS =================
export const getLastPosts = createAsyncThunk(
  "analysis/lastPosts",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/analysis/lastPosts");
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
